import React, { useMemo, useState } from "react";
import { Switch, Button, Select, Tooltip } from "components";
import {
  AlignJustifyStart,
  AlignJustifyCenter,
  AlignJustifyEnd,
  // AlignEnd,
  // AlignCenter,
  // SinleAlignIcon,
  // DoubleAlignIcon,
  AlertIcon,
  CrossIcon,
  SingleLeftIcon,
  SingleRightIcon,
} from "assets/images";
import {
  PRODUCT,
  RAILS,
  CEILING_HEIGHT,
  RAIL_INCHES,
  GRAINS,
  pixelPerInch,
} from "constants/appConstant";
import HeadwallColor from "components/common/modal/Headwall-color";
import {
  chaseAlert,
  deleteAlert,
  warningAlert,
} from "config/sweet-alert/alert";
import { useHeadWallStore, useRightPanelStore } from "store";

function DesignPanel() {
  const { values, setValues } = useHeadWallStore();
  const { updateStepCompletion } = useRightPanelStore();

  const [showModal, setShowModal] = useState({ open: false, index: null });

  const {
    width,
    ceiling_height,
    add_rail,
    headwalls,
    model,
    custom_finish,
    accessory_rails,
    sub_model,
  } = values;

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    const newHeadWallArray = [...headwalls];
    if (type !== "checkbox") setValues({ ...values, [name]: value });
    else {
      const checkServicesExist = newHeadWallArray.some((rails) => {
        return rails.services.length;
      });
      if (checkServicesExist)
        chaseAlert(
          "Please keep in mind that the entire design will be deleted and this process cannot be reversible.",
          handleClearServices
        );
      else setValues({ ...values, [name]: checked, chase_position: "no" });
    }
  };

  const handleRailHeightWidth = (e, dimension, index) => {
    const { name, value } = e.target;
    const newHeadWallArray = [...headwalls];
    const checkServicesExist = newHeadWallArray.some((rails) => {
      return rails.services.length;
    });
    // Iterate over the keys of `accessory_rails` and collect overlapping services
    const checkAccessoriesRails = Object.keys(accessory_rails).some(
      (key) =>
        Array.isArray(accessory_rails[key]) && accessory_rails[key].length > 0
    );
    if (checkServicesExist || checkAccessoriesRails)
      chaseAlert(
        "If you change the headwall length , your services, rails, and accessories will be cleared.",
        handleClearServices
      );
    else {
      if (
        dimension === "ceiling_height" &&
        ceiling_height.ft === 12 &&
        name === "in" &&
        value > 0
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Maximum Ceiling Height should be 12ft only.",
          },
        });
      } else if (
        dimension === "ceiling_height" &&
        ceiling_height.in > 0 &&
        name === "ft" &&
        value >= 12
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Maximum Ceiling Height should be 12ft only.",
          },
        });
      } else if (
        model === PRODUCT.INFINITY &&
        ((dimension === "width" && !width.ft && name === "in" && value < 5) ||
          (dimension === "width" && width.in < 5 && name === "ft" && value < 1))
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Minimum Width should be 5 inches.",
          },
        });
      } else if (
        model === PRODUCT.INFINITY &&
        ((dimension === "width" &&
          width.ft === 17 &&
          name === "in" &&
          value > 0) ||
          (dimension === "width" &&
            width.in > 0 &&
            name === "ft" &&
            value > 16))
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Maximum Width should be 17ft only.",
          },
        });
      } else if (
        model === PRODUCT.AXIOM &&
        ((dimension === "width" && !width.ft && name === "in" && value < 11) ||
          (dimension === "width" &&
            width.in < 11 &&
            name === "ft" &&
            value < 1))
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Minimum Width should be 11 inches.",
          },
        });
      } else if (
        model === PRODUCT.AXIOM &&
        ((dimension === "width" &&
          width.ft === 6 &&
          name === "in" &&
          value > 0) ||
          (dimension === "width" && width.in > 0 && name === "ft" && value > 5))
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Maximum Width should be 6ft only.",
          },
        });
      } else if (
        model === PRODUCT.ELOQUENCE &&
        ((dimension === "width" &&
          width.ft <= 2 &&
          name === "in" &&
          value < 6) ||
          (dimension === "width" &&
            width.in <= 6 &&
            name === "ft" &&
            value < 2))
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Minimum Width should be 30 inches.",
          },
        });
      } else if (
        model === PRODUCT.ELOQUENCE &&
        ((dimension === "width" &&
          width.ft === 7 &&
          name === "in" &&
          value > 6) ||
          (dimension === "width" && width.in > 6 && name === "ft" && value > 7))
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Maximum Width should be 90 inches only.",
          },
        });
      } else if (
        model === PRODUCT.SECURITY &&
        sub_model === "enclosure" &&
        ((dimension === "width" &&
          width.ft < 1 &&
          name === "in" &&
          value < 8) ||
          (dimension === "width" &&
            width.in <= 8 &&
            name === "ft" &&
            value < 1))
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Minimum Width should be 8 inches.",
          },
        });
      } else if (
        model === PRODUCT.SECURITY &&
        sub_model === "enclosure" &&
        ((dimension === "width" &&
          width.ft === 5 &&
          name === "in" &&
          value > 11) ||
          (dimension === "width" &&
            width.in > 5 &&
            name === "ft" &&
            value > 11))
      ) {
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            ftError: "Maximum Width should be 5 ft and 11 inches only.",
          },
        });
      } else if (
        (model === PRODUCT.COMPASS || model === PRODUCT.ARRAY) &&
        dimension === "width"
      ) {
        const newArr = [...headwalls];
        newArr[index].width = value;
        setValues({ ...values, headwalls: newArr });
      } else
        setValues({
          ...values,
          [dimension]: {
            ...values[dimension],
            [name]: Number(value),
            ftError: "",
          },
        });
    }
  };

  const handleChase = (pos) => {
    const newHeadWallArray = [...headwalls];
    const accessoryRails = { ...accessory_rails };
    const checkServicesExist = newHeadWallArray.some((rails) => {
      return rails.services.length;
    });
    const hasAnyAccessoryRails = Object.values(accessoryRails)?.some(
      (arr) => Array.isArray(arr) && arr.length > 0
    );
    if (checkServicesExist || hasAnyAccessoryRails)
      chaseAlert(
        "Please keep in mind that the entire design will be deleted and this process cannot be reversible.",
        handleClearServices
      );
    else
      setValues({
        ...values,
        chase_position: pos,
        accessory_rails: {
          surface_mounted: [],
          embedded: [],
          unimount: [],
          direct: [],
        },
      });
  };

  const handleClearServices = () => {
    const newRails = [...headwalls];
    newRails.map((rail) => {
      rail.services.length = 0;
      return rail;
    });
    setValues({
      ...values,
      headwalls: newRails,
      add_rail: add_rail,
      accessory_rails: {
        surface_mounted: [],
        embedded: [],
        unimount: [],
        direct: [],
      },
    });
    updateStepCompletion(5, false);
  };

  const handleRails = (e) => {
    const { name } = e.target;
    const rails = [...headwalls];
    if (model === PRODUCT.AXIOM) {
      const sectionWidth = (width.ft * 12 + width.in) / pixelPerInch;
      const checkAccessories = accessory_rails["direct"].filter(
        (acc) => acc?.positions?.x > sectionWidth
      );
      if (
        rails.length > 1 &&
        (rails[1]?.services?.length || checkAccessories.length)
      ) {
        deleteAlert(
          handleAddRemoveRails,
          "Are you sure you wish to discard the second panel?",
          "If you remove the panel, your services, rails, and accessories placed over it will be cleared.",
          "Yes, Discard!",
          name
        );
      } else handleAddRemoveRails(name);
    } else if (model === PRODUCT.INFINITY) {
      if (rails.length >= 1) {
        const checkServiceExist = rails
          .filter(
            (r) =>
              (r.position === "top" || r.position === "bottom") &&
              r.services.length > 0
          )
          .map((r) => r.services);
        let checkAccessorieRail = false;
        if (name === "both" && rails.length === 3) checkAccessorieRail = false;
        else checkAccessorieRail = checkAccessorieRailPositions(name);

        if (checkAccessorieRail) {
          warningAlert(
            "Sorry, you cannot add rail here, because accessories are intersecting with rails"
          );
          return;
        }
        // to check that is there any accessory on rail
        const tempName =
          name === "bottom" ? "top" : name === "top" ? "bottom" : name;
        let checkAccessories = false;
        if (name === "both" && rails.length < 3) checkAccessories = false;
        else checkAccessories = checkAccessorieRailPositions(tempName);
        if (checkServiceExist.length || checkAccessories) {
          deleteAlert(
            handleAddRemoveRails,
            "Are you sure you wish to discard the rail?",
            "If you remove the rail, your services and accessories placed over it will be cleared.",
            "Yes, Discard!",
            name
          );
        } else handleAddRemoveRails(name);
      } else handleAddRemoveRails(name);
    }
  };

  const handleAddRemoveRails = (name) => {
    let newValue;
    if (name === add_rail) newValue = "no";
    else newValue = name;
    const { rails, accessorieRails } = addRails(name);
    setValues({
      ...values,
      headwalls: rails,
      add_rail: newValue,
      accessory_rails: accessorieRails,
    });
  };

  const addRails = (position) => {
    let rails;
    switch (position) {
      case "top":
        rails = addTopRail();
        return rails;
      case "bottom":
        rails = addBottomRail();
        return rails;
      // case "both":
      //   rails = addBothRail();
      // return rails;
      case "single":
        rails = addSingleRail();
        return rails;
      case "double":
        rails = addDoubleRail();
        return rails;
      case "no":
        rails = removeBothRows();
        return rails;
      default:
        return "";
    }
  };

  const addTopRail = () => {
    const rails = [...headwalls];
    let accessorieRails = { ...accessory_rails };
    const checkTopRail = rails.findIndex((rail) => rail.position === "top");
    // const checkBottomRail = rails.findIndex(
    //   (rail) => rail.position === "bottom"
    // );
    // if (checkBottomRail !== -1) rails.splice(checkBottomRail, 1);
    if (checkTopRail === -1)
      rails.unshift({
        position: "top",
        services: [],
        color: "",
        background: "7953",
      });
    else rails.splice(checkTopRail, 1);
    //remove bottom rail accessories
    const newAccObj = accessorieRails["direct"].filter(
      (rail) => rail?.mount_type === "rail" && rail?.positions?.y < 900
    );
    accessorieRails["direct"] = newAccObj;
    return { rails, accessorieRails };
  };

  const addBottomRail = () => {
    const rails = [...headwalls];
    let accessorieRails = { ...accessory_rails };
    const checkBottomRail = rails.findIndex(
      (rail) => rail.position === "bottom"
    );
    // const checkTopRail = rails.findIndex((rail) => rail.position === "top");
    // if (checkTopRail !== -1) rails.splice(checkTopRail, 1);
    if (checkBottomRail === -1)
      rails.push({
        position: "bottom",
        services: [],
        color: "",
        background: "7953",
      });
    else rails.splice(checkBottomRail, 1);
    //remove top  rail accessories
    const newAccObj = accessorieRails["direct"].filter(
      (rail) => rail?.mount_type === "rail" && rail?.positions?.y > 600
    );
    accessorieRails["direct"] = newAccObj;
    return { rails, accessorieRails };
  };

  // const addBothRail = () => {
  //   const rails = [...headwalls];
  //   const accessorieRails = { ...accessory_rails };
  //   const checkTopRail = rails.find((rail) => rail.position === "top");
  //   const checkBottomRail = rails.find((rail) => rail.position === "bottom");
  //   if (!checkTopRail)
  //     rails.unshift({
  //       position: "top",
  //       services: [],
  //       color: "",
  //       background: "7953",
  //     });
  //   if (!checkBottomRail)
  //     rails.push({
  //       position: "bottom",
  //       services: [],
  //       color: "",
  //       background: "7953",
  //     });
  //   return { rails, accessorieRails };
  // };

  const removeBothRows = () => {
    const accessorieRails = { ...accessory_rails };
    const rails = [...headwalls];
    const topRailIndex = rails.findIndex((rail) => rail.position === "top");
    if (topRailIndex !== -1) rails.splice(topRailIndex, 1);
    const bottomRailIndex = rails.findIndex(
      (rail) => rail.position === "bottom"
    );
    if (bottomRailIndex !== -1) rails.splice(bottomRailIndex, 1);
    const leftRailIndex = rails.findIndex((rail) => rail.position === "right");
    if (leftRailIndex !== -1) {
      rails.splice(leftRailIndex, 1);
    }
    // const sectionWidth = width.ft * 12 + width.in;
    // const accessorieRails = filterAccessoryRails(accRailsObj, sectionWidth);
    // console.log({accessorieRails})

    //remove top and bottom rail accessories
    const newAccObj = accessorieRails["direct"].filter(
      (rail) =>
        rail.mount_type === "rail" &&
        rail?.positions?.y > 600 &&
        rail?.positions?.y > 900
    );
    accessorieRails["direct"] = newAccObj;
    return { rails, accessorieRails };
  };

  const addSingleRail = () => {
    const accRailsObj = { ...accessory_rails };
    const sectionWidth = width.ft * 12 + width.in;
    const rails = [...headwalls];
    const checkLeftRail = rails.findIndex((rail) => rail.position === "right");
    if (checkLeftRail !== -1) rails.splice(checkLeftRail, 1);
    const accessorieRails = filterAccessoryRails(accRailsObj, sectionWidth);
    return { rails, accessorieRails };
  };

  const addDoubleRail = () => {
    const accessorieRails = { ...accessory_rails };
    const rails = [...headwalls];
    const checkSecondRail = rails.findIndex(
      (rail) => rail.position === "right"
    );
    if (checkSecondRail === -1)
      rails.push({
        position: "right",
        services: [],
        color: "",
        background: "7953",
      });
    else rails.splice(checkSecondRail, 1);
    return { rails, accessorieRails };
  };

  const railDimensions = useMemo(() => {
    if (model === PRODUCT.INFINITY) return RAILS.INFINITY;
    else if (model === PRODUCT.ELOQUENCE) return RAILS.ELOQUENCE;
    else if (model === PRODUCT.CONSOLE) return RAILS.CONSOLE;
    else if (model === PRODUCT.SECURITY) {
      if (sub_model === "surface_mounted")
        return RAILS.SECURITY_SURFACE_MOUNTED;
      else if (sub_model === "enclosure") return RAILS.SECURITY_ENCLOUSRE;
      else if (sub_model === "recessed") return RAILS.SECURITY_RECESSED;
      else if (sub_model === "insight") return RAILS.SECURITY_INSIGHT;
    } else if (model === PRODUCT.HIDDEN) {
      if (sub_model === "single") return RAILS.HIDDEN_SINGLE;
      else if (sub_model === "double") return RAILS.HIDDEN_DOUBLE;
    } else return RAILS.AXIOM;
  }, [model, sub_model]);

  const handleAddSection = () => {
    const newArr = [...headwalls];
    const width = model === PRODUCT.COMPASS ? 12 : 2;
    newArr.push({
      position: "",
      services: [],
      width: width,
      color: "",
      background: "7953",
    });
    setValues({ ...values, headwalls: newArr });
  };

  const handleRemoveSectionAlert = () => {
    const newArr = [...headwalls];
    // Iterate over the keys of `accessory_rails` and collect overlapping services
    const checkAccessoriesRails = Object.keys(accessory_rails).some(
      (key) =>
        Array.isArray(accessory_rails[key]) && accessory_rails[key].length > 0
    );
    if (
      (newArr.length > 1 && newArr[newArr.length - 1].services.length) ||
      checkAccessoriesRails
    )
      deleteAlert(
        handleRemoveSection,
        "Are you sure you wish to discard this section?",
        "If you remove the section, your services, rails, and accessories placed over it will be cleared.",
        "Yes, Discard!"
      );
    else handleRemoveSection();
  };

  const handleRemoveSection = () => {
    const newArr = [...headwalls];
    const accRailsObj = { ...accessory_rails };
    newArr.pop();
    const headwallLength = newArr.reduce(
      (acc, curr) =>
        acc + Number(model === PRODUCT.COMPASS ? curr.width : curr.width * 12),
      0
    );

    const accessorieRails = filterAccessoryRails(accRailsObj, headwallLength);

    setValues({
      ...values,
      accessory_rails: accessorieRails,
      headwalls: newArr,
    });
  };

  const filterAccessoryRails = (accessory_rails, headwallWidth) => {
    const filteredRails = {};
    headwallWidth = headwallWidth / pixelPerInch;
    // Iterate through each key in the accessory_rails object
    Object.keys(accessory_rails).forEach((key) => {
      const rails = accessory_rails[key];

      filteredRails[key] = rails.filter((rail) => {
        const railWidth = rail.width / pixelPerInch;
        const railRightEdge =
          model === PRODUCT.AXIOM
            ? rail.positions.x
            : rail.positions.x + railWidth;
        // Remove rails where positions.x or railRightEdge exceed the headwall width
        return (
          rail.positions.x <= headwallWidth && railRightEdge <= headwallWidth
        );
      });
    });

    return filteredRails;
  };

  const checkAccessorieRailPositions = (position) => {
    const restricted_ranges = [
      { start: 272.32142857128576, end: 642.8571428571429 }, // top
      { start: 1236.607142857, end: 1714.2857142857142 }, // bottom
    ];

    const isInRange = (railTop, railBottom, range) =>
      (railTop >= range.start && railTop <= range.end) ||
      (railBottom >= range.start && railBottom <= range.end) ||
      (railTop <= range.start && railBottom >= range.end);

    // Loop through all accessory rails
    for (const key of Object.keys(accessory_rails)) {
      let rails = [];
      if (key === "direct")
        rails = accessory_rails[key].filter(
          (rail) => rail.mount_type === "direct" || rail.mount_type === "rail"
        );
      else rails = accessory_rails[key];

      for (const rail of rails) {
        const railTop = rail.positions.y;
        const railBottom = rail.positions.y + rail.height / pixelPerInch;

        if (
          position === "top" &&
          isInRange(railTop, railBottom, restricted_ranges[0])
        ) {
          return true;
        }

        if (
          position === "bottom" &&
          isInRange(railTop, railBottom, restricted_ranges[1])
        ) {
          return true;
        }

        if (
          position === "both" &&
          (isInRange(railTop, railBottom, restricted_ranges[0]) ||
            isInRange(railTop, railBottom, restricted_ranges[1]))
        ) {
          return true;
        }
      }
    }

    return false; // No rail matched the restricted ranges
  };

  const handleEquolenceRails = (e, railIndex) => {
    const { checked } = e.target;
    const currentRails = [...headwalls];
    const railCount = currentRails.length;

    // Template for a new rail
    const createRail = () => ({
      position: "",
      services: [],
      width: 0,
      color: "",
      background: "7953",
    });

    // Case: User tries to add 4th rail directly
    if (checked && railIndex === 3 && railCount < 3) {
      const railsToAdd = 4 - railCount;
      const newRails = Array.from({ length: railsToAdd }, createRail);
      const updatedRails = [...currentRails, ...newRails];
      setValues({ ...values, headwalls: updatedRails });
      return;
    }

    // Case: Prevent removing 3rd rail when 4th still exists
    if (!checked && railIndex === 2 && railCount === 4) {
      warningAlert("Please remove the fourth rail before disabling the third.");
      return;
    }

    // Normal toggle add/remove
    let updatedRails = [];
    if (checked) {
      updatedRails = [...currentRails, createRail()];
      setValues({ ...values, headwalls: updatedRails });
    } else {
      const checkServiceExist = headwalls[railIndex].services;
      if (checkServiceExist.length) {
        chaseAlert(
          "If you change the headwall length , your services, rails, and accessories will be cleared.",
          handleRemoveEquolenceRail,
          currentRails
        );
      } else {
        handleRemoveEquolenceRail(currentRails);
      }
    }

    // const updatedRails = checked
    //   ? [...currentRails, createRail()]
    //   : currentRails.slice(0, -1);

    // setValues({ ...values, headwalls: updatedRails });
  };

  const handleRemoveEquolenceRail = (currentRails) => {
    const updatedRails = currentRails.slice(0, -1);
    setValues({ ...values, headwalls: updatedRails });
  };

  const handleInsightConsoleRails = (e) => {
    const { checked } = e.target;
    const currentRails = [...headwalls];

    // Template for a new rail
    const createRail = () => ({
      position: "",
      services: [],
      width: 0,
      color: headwalls[0].color,
      background: "",
    });

    // Normal toggle add/remove
    const updatedRails = checked
      ? [...currentRails, createRail()]
      : currentRails.slice(0, -1);

    setValues({ ...values, headwalls: updatedRails });
  };

  const handleSlideDoor = (newValue) => {
    setValues({
      add_rail: newValue,
    });
  };

  return (
    <>
      {showModal.open && (
        <HeadwallColor setShowModal={setShowModal} index={showModal.index} />
      )}
      <div className="overflow-auto newheightDesign mt-8 pr-2 border-t-2 border-slate-300">
        {(() => {
          switch (model) {
            case PRODUCT.INFINITY:
              return (
                <InfinityDesginOptions
                  values={values}
                  railDimensions={railDimensions}
                  handleRailHeightWidth={handleRailHeightWidth}
                  handleRails={handleRails}
                  handleChange={handleChange}
                  handleChase={handleChase}
                  setShowModal={setShowModal}
                />
              );
            case PRODUCT.AXIOM:
              return (
                <AxiomDesginOptions
                  values={values}
                  railDimensions={railDimensions}
                  handleRailHeightWidth={handleRailHeightWidth}
                  handleRails={handleRails}
                  handleChange={handleChange}
                  setShowModal={setShowModal}
                />
              );
            case PRODUCT.COMPASS:
              return (
                <CompassDesginOptions
                  values={values}
                  handleAddSection={handleAddSection}
                  handleRemoveSectionAlert={handleRemoveSectionAlert}
                  handleRailHeightWidth={handleRailHeightWidth}
                  setShowModal={setShowModal}
                />
              );
            case PRODUCT.ARRAY:
              return (
                <CompassDesginOptions
                  values={values}
                  handleAddSection={handleAddSection}
                  handleRemoveSectionAlert={handleRemoveSectionAlert}
                  handleRailHeightWidth={handleRailHeightWidth}
                  setShowModal={setShowModal}
                />
              );
            case PRODUCT.CONSOLE:
              return (
                <ConsoleDesginOptions
                  values={values}
                  railDimensions={railDimensions}
                  handleRailHeightWidth={handleRailHeightWidth}
                  setShowModal={setShowModal}
                  handleInsightConsoleRails={handleInsightConsoleRails}
                />
              );
            case PRODUCT.SECURITY:
              return (
                <ConsoleDesginOptions
                  values={values}
                  railDimensions={railDimensions}
                  handleRailHeightWidth={handleRailHeightWidth}
                  setShowModal={setShowModal}
                  handleInsightConsoleRails={handleInsightConsoleRails}
                />
              );
            case PRODUCT.ELOQUENCE:
              return (
                <EloquenceDesignOptions
                  values={values}
                  handleRailHeightWidth={handleRailHeightWidth}
                  setShowModal={setShowModal}
                  railDimensions={railDimensions}
                  handleEquolenceRails={handleEquolenceRails}
                />
              );
            case PRODUCT.HIDDEN:
              return (
                <HiddenHeadwallDesignOptions
                  values={values}
                  handleRailHeightWidth={handleRailHeightWidth}
                  setShowModal={setShowModal}
                  railDimensions={railDimensions}
                  handleSlideDoor={handleSlideDoor}
                />
              );
            default:
              return (
                <InfinityDesginOptions
                  values={values}
                  railDimensions={railDimensions}
                  handleRailHeightWidth={handleRailHeightWidth}
                  handleRails={handleRails}
                  handleChange={handleChange}
                  handleChase={handleChase}
                />
              );
          }
        })()}

        <div className="pt-4 mt-8 border-t-2 border-slate-300">
          <p className="font-bold text-base txtBlue headingTxt">
            Specified Finish
          </p>

          <div className="flex items-center justify-between my-3 gap-2 color_input">
            <textarea
              name="custom_finish"
              rows="3"
              className="bg-white w-full p-2 rounded font-bold text-xs border border-slate-300"
              placeholder="Type Specified Finish here..."
              value={custom_finish}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default DesignPanel;

const HeadwallLength = ({
  width,
  ceiling_height,
  railDimensions,
  handleRailHeightWidth,
}) => {
  return (
    <div className="pt-4 mt-8 border-t-2 border-slate-300">
      <p className="font-bold text-base txtBlue headingTxt">Headwall Length</p>
      <div className="grid gap-4 grid-cols-2 my-2 ">
        <div>
          <div className="flex items-center ">
            <div className="flex rounded border border-teal-700 pt-1 pb-2  px-2 bg-white  w-full">
              <span className="borderBottom w-[50%]">
                <Select
                  name="ft"
                  className="bg-white  font-bold text-xs  my-0 mx-[2px] text-center w-full"
                  options={railDimensions}
                  value={width.ft}
                  handleSelect={(e) => handleRailHeightWidth(e, "width")}
                />
              </span>
              <span className="borderBottom w-[50%]">
                <Select
                  name="in"
                  className="bg-white borderBottom font-bold text-xs  my-0 mx-[2px] text-center w-full"
                  options={RAIL_INCHES}
                  value={width.in}
                  handleSelect={(e) => handleRailHeightWidth(e, "width")}
                />
              </span>
            </div>
          </div>
          <p className="font-medium text-sm flex pl-0">
            <small className=" font-medium txtBlue">Width (ft/in)</small>
          </p>
        </div>
        <div>
          <div className="flex items-center">
            <div className="flex rounded border border-teal-700 pt-1 pb-2 px-2 bg-white   w-full">
              <span className="borderBottom w-[50%]">
                <Select
                  name="ft"
                  className="bg-white font-bold text-xs text-center w-full   my-0 mx-[2px]"
                  options={CEILING_HEIGHT}
                  value={ceiling_height.ft}
                  handleSelect={(e) =>
                    handleRailHeightWidth(e, "ceiling_height")
                  }
                />
              </span>
              <span className="borderBottom w-[50%]">
                <Select
                  name="in"
                  className="bg-white font-bold text-xs text-center w-full  my-0 mx-[2px]"
                  options={RAIL_INCHES}
                  value={ceiling_height.in}
                  handleSelect={(e) =>
                    handleRailHeightWidth(e, "ceiling_height")
                  }
                />
              </span>
            </div>
          </div>
          <p className="font-medium text-sm flex pl-0 ">
            <small className=" font-medium txtBlue">
              Ceiling Height (ft/in)
            </small>
          </p>
        </div>
      </div>
      {/* errors */}
      {width.ftError && (
        <div className=" flex items-center text-xs font-normal text-yellow-600">
          <img
            src={AlertIcon}
            alt="..img"
            className="mx-2"
            style={{ height: "20px" }}
          />
          {width.ftError}
        </div>
      )}
      {ceiling_height.ftError && (
        <div className=" flex items-center text-xs font-normal text-yellow-600">
          <img
            src={AlertIcon}
            alt="..img"
            className="mx-2"
            style={{ height: "20px" }}
          />
          {ceiling_height.ftError}
        </div>
      )}
    </div>
  );
};

const InfinityDesginOptions = ({
  values,
  railDimensions,
  handleRailHeightWidth,
  handleRails,
  handleChange,
  handleChase,
  setShowModal,
}) => {
  const {
    width,
    ceiling_height,
    chased,
    chase_position,
    // add_rail,
    headwalls,
    chase_color,
    chase_background,
  } = values;

  const rails = [
    { label: "Center Rail", value: "middle", index: 1 },
    { label: "Upper Rail", value: "top", index: 0 },
    { label: "Lower Rail", value: "bottom", index: 2 },
  ];

  const chaseOptions = [
    { pos: "left", icon: AlignJustifyStart },
    { pos: "center", icon: AlignJustifyCenter },
    { pos: "right", icon: AlignJustifyEnd },
  ];

  const findHeadwallIndex = (headwalls, position) =>
    headwalls.findIndex((h) => h.position === position);

  return (
    <>
      <div className="my-4">
        <p className="font-bold text-base txtBlue headingTxt">Rails</p>
        {/* <div className="flex justify-between my-2">
          <div className="w-[80px]">
            <Button
              className={`flex w-full h-12 flex-col border justify-center items-center py-2 px-4 rounded font-bold text-xs bg-white  right_panel_step_box_active cursor-pointer rotate-180 ${
                add_rail === "top" ? "  opacity-100" : "opacity-50"
              }`}
              imgPath={AlignEnd}
              handleClick={() => handleRails("top")}
              type={"button"}
              imgClass={"h-6 w-6"}
            />
            <div className="font-medium text-sm txtBlue flex justify-between mt-3 px-1">
              <p>Top</p>
              <div
                className="rounded border border-slate-300 h-[22px] w-[22px] cursor-pointer "
                style={{
                  backgroundColor: headwalls[0]?.color,
                  backgroundImage: `url(${GRAINS[headwalls[0]?.background]})`,
                }}
                onClick={() => setShowModal({ open: true, index: 0 })}
              />
            </div>
          </div>

          <div className="w-[80px]">
            <Button
              className={`flex w-full h-12 flex-col border justify-center items-center py-2 px-4 rounded font-bold text-xs  right_panel_step_box_active cursor-pointer  ${
                add_rail === "bottom" ? "  opacity-100" : " opacity-50"
              }`}
              imgPath={AlignEnd}
              handleClick={() => handleRails("bottom")}
              type={"button"}
              imgClass={"h-6 w-6"}
            />
            <div className="font-medium text-sm txtBlue flex justify-between mt-3 px-1">
              <p>Middle</p>
              <div
                className="rounded border border-slate-300 h-[22px] w-[22px] cursor-pointer "
                style={{
                  backgroundColor: headwalls[1]?.color,
                  backgroundImage: `url(${GRAINS[headwalls[1]?.background]})`,
                }}
                onClick={() => {
                  headwalls.length >= 2 &&
                    setShowModal({ open: true, index: 1 });
                }}
              />
            </div>
          </div>
          <div className="w-[80px]">
            <Button
              className={`flex w-full h-12 flex-col border justify-center items-center py-2 px-4 rounded font-bold text-xs right_panel_step_box_active cursor-pointer  ${
                add_rail === "both" ? "  opacity-100" : " opacity-50"
              }`}
              imgPath={AlignCenter}
              handleClick={() => handleRails("both")}
              type={"button"}
              imgClass={"h-6 w-6"}
            />
            <div className="font-medium text-sm txtBlue flex justify-between mt-3 px-1">
              <p>Bottom</p>
              <div
                className="rounded border border-slate-300 h-[22px] w-[22px] cursor-pointer "
                style={{
                  backgroundColor: headwalls[2]?.color,
                  backgroundImage: `url(${GRAINS[headwalls[2]?.background]})`,
                }}
                onClick={() => {
                  headwalls.length === 3 &&
                    setShowModal({ open: true, index: 2 });
                }}
              />
            </div>
          </div>
        </div> */}
        {rails.map(({ label, value, index }) => {
          const hwIndex = findHeadwallIndex(headwalls, value);
          const hw = headwalls[hwIndex]; // could be undefined if not added
          return (
            <div key={index} className="flex items-center my-2">
              <span className="txtBlue font-bold text-[13px] min-w-[50%]">
                {label}{" "}
                {index === 1 && (
                  <small className="text-xs font-normal">(Default)</small>
                )}
              </span>
              <div className="grid items-center gap-5 grid-cols-2 ml-5">
                <div
                  className="rounded border border-slate-300 h-[32px] w-[32px] cursor-pointer"
                  style={{
                    backgroundColor: hw?.color,
                    backgroundImage: `url(${GRAINS[hw?.background]})`,
                  }}
                  onClick={() => {
                    if (hw) {
                      setShowModal({ open: true, index: hwIndex });
                    }
                  }}
                />
                {index !== 1 && (
                  <Switch
                    name={value}
                    value={!!hw}
                    handleSwitch={handleRails}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
      <HeadwallLength
        width={width}
        ceiling_height={ceiling_height}
        railDimensions={railDimensions}
        handleRailHeightWidth={handleRailHeightWidth}
      />

      <div className="flex items-center justify-between my-4 pt-4 mt-8 border-t-2 border-slate-300">
        <p className="font-bold text-base txtBlue headingTxt">Chase Needed</p>
        <Switch name="chased" handleSwitch={handleChange} value={chased} />
      </div>
      {chased && (
        <div className="my-4">
          {/* Position buttons */}
          <div className="flex justify-between mb-4 w-full" role="group">
            {chaseOptions.map(({ pos, icon }) => (
              <Button
                key={pos}
                className={`flex w-1/2.8 h-12 flex-col border justify-center items-center py-2 px-4 rounded font-bold text-xs right_panel_step_box_active cursor-pointer ${
                  chase_position === pos
                    ? "opacity-100"
                    : "chase_needed opacity-50"
                }`}
                imgPath={icon}
                handleClick={() => handleChase(pos)}
                type="button"
                imgClass="h-6 w-6"
              />
            ))}
          </div>

          {/* Color selector */}
          <div className="font-medium text-sm txtBlue flex mt-3 px-1">
            <p>Chase color</p>
            <div
              className="rounded border border-slate-300 h-[22px] w-[22px] cursor-pointer ml-3"
              style={{
                backgroundColor: chase_color,
                backgroundImage: `url(${GRAINS[chase_background]})`,
              }}
              onClick={() => {
                if (chase_position !== "no") {
                  setShowModal({ open: true });
                }
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

const AxiomDesginOptions = ({
  values,
  railDimensions,
  handleRailHeightWidth,
  handleRails,
  setShowModal,
}) => {
  const { width, ceiling_height, headwalls } = values;
  const rails = [
    { label: "Single Rail", value: "single", index: 0 },
    { label: "Double Rail", value: "double", index: 1 },
  ];
  return (
    <>
      <div className="my-4  ">
        <p className="font-bold text-base txtBlue headingTxt">Panels</p>
        {/* <div className="flex my-2">
          <div className="w-1/3 ">
            <Button
              name={"single"}
              className={`flex h-12 w-full flex-col border justify-center items-center py-2 px-4 rounded font-bold text-xs bg-white  right_panel_step_box_active cursor-pointer ${
                add_rail === "single" ? "  opacity-100" : " opacity-50"
              }`}
              imgPath={SinleAlignIcon}
              handleClick={handleRails}
              type={"button"}
            />
            <div className="font-bold text-base txtBlue flex justify-between mt-3 px-2">
              <p>Left</p>
              <div
                className="rounded border border-slate-300 h-[22px] w-[22px] cursor-pointer "
                style={{
                  backgroundColor: headwalls[0]?.color,
                  backgroundImage: `url(${GRAINS[headwalls[0]?.background]})`,
                }}
                onClick={() => setShowModal({ open: true, index: 0 })}
              />
            </div>
          </div>
          <div className="w-1/3 h-12 mx-4">
            <Button
              name={"double"}
              className={`flex w-full h-full flex-col border justify-center items-center py-2 px-4 rounded font-bold text-xs  right_panel_step_box_active cursor-pointer  ${
                add_rail === "double" ? "  opacity-100" : " opacity-50"
              }`}
              imgPath={DoubleAlignIcon}
              handleClick={handleRails}
              type={"button"}
            />
            <div className="font-bold text-base txtBlue flex justify-between mt-3 px-2">
              <p>Right</p>
              <div
                className="rounded border border-slate-300 h-[22px] w-[22px] cursor-pointer"
                style={{
                  backgroundColor: headwalls[1]?.color,
                  backgroundImage: `url(${GRAINS[headwalls[1]?.background]})`,
                }}
                onClick={() => {
                  headwalls.length > 1 &&
                    setShowModal({ open: true, index: 1 });
                }}
              />
            </div>
          </div>
        </div> */}
        {rails.map(({ label, value, index }) => {
          return (
            <div key={index} className="flex items-center my-2">
              <span className="txtBlue font-bold text-[13px] min-w-[50%]">
                {label}{" "}
                {index === 1 && (
                  <small className="text-xs font-normal">(Default)</small>
                )}
              </span>
              <div className="grid items-center gap-5 grid-cols-2 ml-5">
                <div
                  className="rounded border border-slate-300 h-[32px] w-[32px] cursor-pointer"
                  style={{
                    backgroundColor: headwalls[index]?.color,
                    backgroundImage: `url(${
                      GRAINS[headwalls[index]?.background]
                    })`,
                  }}
                  onClick={() => {
                    if (headwalls[index]) {
                      setShowModal({ open: true, index: index });
                    }
                  }}
                />
                {index > 0 && (
                  <Switch
                    name={value}
                    value={!!headwalls[index]}
                    handleSwitch={handleRails}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
      <HeadwallLength
        width={width}
        ceiling_height={ceiling_height}
        railDimensions={railDimensions}
        handleRailHeightWidth={handleRailHeightWidth}
      />
    </>
  );
};

const CompassDesginOptions = ({
  values,
  handleAddSection,
  handleRemoveSectionAlert,
  handleRailHeightWidth,
  setShowModal,
}) => {
  const { ceiling_height, headwalls, model } = values;
  const width_options = model === PRODUCT.COMPASS ? RAILS.COMPASS : RAILS.ARRAY;
  const measurement = model === PRODUCT.COMPASS ? "inch" : "ft";
  return (
    <div className="my-4">
      <p className="font-semibold text-base txtBlue headingTxt">Sections</p>
      <div className=" border-b-2 border-slate-300">
        {!!headwalls.length &&
          headwalls.map((wall, i) => (
            <div className="flex items-center justify-between  my-2" key={i}>
              <span className="txtBlue font-bold text-[13px]">
                Section {i + 1}{" "}
                <small className="text-xs font-normal">
                  Width ({measurement})
                </small>
              </span>

              <div
                className="grid items-center  gap-2"
                style={{ gridTemplateColumns: "56px 22px 20px" }}
              >
                <div className="selectwidth">
                  <span className="borderBottomMini w-[50%] font-bold text-xs left-[2px]">
                    <Select
                      name="in"
                      className=""
                      options={width_options}
                      value={wall.width}
                      handleSelect={(e) => handleRailHeightWidth(e, "width", i)}
                    />
                  </span>
                </div>
                <div
                  className="rounded border border-slate-300 h-[22px] w-[22px] cursor-pointer"
                  style={{
                    backgroundColor: wall?.color,
                    backgroundImage: `url(${GRAINS[wall?.background]})`,
                  }}
                  onClick={() => setShowModal({ open: true, index: i })}
                />
                <Tooltip
                  class_name={`${
                    i === headwalls.length - 1 && i !== 0
                      ? "cursor-pointer"
                      : "opacity-0 pointer-events-none"
                  }`}
                  icon={CrossIcon}
                  title={"Remove Section"}
                  handleClick={handleRemoveSectionAlert}
                />
              </div>
            </div>
          ))}
        {headwalls.length < 5 && (
          <div className="flex justify-end w-11/12">
            <Button
              text={"Add Section"}
              className="login_btn py-2 px-4 text-white cursor-pointer rounded btnTxt my-2 font-bold"
              handleClick={handleAddSection}
              type={"button"}
            />
          </div>
        )}
      </div>

      <div className="my-2">
        <p className="font-semibold text-base txtBlue headingTxt">
          Headwall Ceiling Height (ft/inch)
        </p>
        <div className="items-center my-2">
          <div className="  selectwidth flex w-1/2 px-3 py-2 gap-4">
            <span className="borderBottomMini w-[50%] font-bold text-xs">
              <Select
                name="ft"
                className=""
                options={CEILING_HEIGHT}
                value={ceiling_height.ft}
                handleSelect={(e) => handleRailHeightWidth(e, "ceiling_height")}
              />
            </span>
            <span className="borderBottomMini w-[50%] font-bold text-xs">
              <Select
                name="in"
                className=""
                options={RAIL_INCHES}
                value={ceiling_height.in}
                handleSelect={(e) => handleRailHeightWidth(e, "ceiling_height")}
              />
            </span>
          </div>
          {ceiling_height.ftError && (
            <div className=" flex items-center text-xs font-normal text-yellow-600 my-1">
              <img
                src={AlertIcon}
                alt="..img"
                className="mx-2"
                style={{ height: "20px" }}
              />
              {ceiling_height.ftError}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const ConsoleDesginOptions = (props) => {
  const {
    values,
    railDimensions,
    handleRailHeightWidth,
    setShowModal,
    handleInsightConsoleRails,
  } = props;
  const rails = [
    { label: "1 (Default)", index: 0 },
    { label: "2 ", index: 1 },
  ];

  const { width, sub_model, headwalls } = values;
  const visibleRails = sub_model === "insight" ? rails : rails.slice(0, 1);
  return (
    <>
      {sub_model !== "enclosure" && sub_model !== "insight" ? (
        <div className="my-4">
          <p className="font-semibold text-base txtBlue headingTxt">Sections</p>
          <div>
            <div className="flex items-center justify-between  my-2">
              <span className="txtBlue font-bold text-[13px]">
                Rail
                <small className="text-xs font-normal"> Width (inch)</small>
              </span>

              <div
                className="grid items-center gap-2"
                style={{ gridTemplateColumns: "80px 22px" }}
              >
                <div className="selectwidth w-[78px]">
                  <span
                    className={`${
                      Number.isInteger(width.in)
                        ? "borderBottomMini"
                        : "borderBottomMiniConsole"
                    } w-[50%] font-bold text-xs left-[2px]`}
                  >
                    <Select
                      name="in"
                      className=""
                      options={railDimensions}
                      value={width.in}
                      handleSelect={(e) => handleRailHeightWidth(e, "width", 0)}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="my-4 border-t-2 border-slate-300 pt-4">
            <p className="font-semibold text-base txtBlue headingTxt">Rails</p>
            <div>
              {visibleRails.map(({ label, index }) => (
                <div key={index} className="flex items-center my-2">
                  <span className="txtBlue font-bold text-[13px] min-w-[50%]">
                    Rail <small className="text-xs font-normal">{label}</small>
                  </span>
                  <div className="grid items-center gap-5 grid-cols-2 ml-5">
                    <div
                      className="rounded border border-slate-300 h-[32px] w-[32px] cursor-pointer"
                      style={{
                        backgroundColor: headwalls[index]?.color,
                        backgroundImage: `url(${
                          GRAINS[headwalls[index]?.background]
                        })`,
                      }}
                      onClick={() => {
                        if (headwalls[index]) {
                          setShowModal({ open: true, index });
                        }
                      }}
                    />
                    {index > 0 && (
                      <Switch
                        name="rail"
                        value={!!headwalls[index]}
                        handleSwitch={(e) => handleInsightConsoleRails(e)}
                        isDisabled={index < 1 ? true : false}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : sub_model === "insight" ? (
        <div className="my-4">
          <p className="font-semibold text-base txtBlue headingTxt">Sections</p>
          <div>
            <div className="flex items-center justify-between  my-2">
              <span className="txtBlue font-bold text-[13px]">
                Rail
                <small className="text-xs font-normal"> Width (inch)</small>
              </span>

              <div
                className="grid items-center gap-2"
                style={{ gridTemplateColumns: "80px 22px" }}
              >
                <div className="selectwidth w-[78px]">
                  <span
                    className={`${
                      Number.isInteger(width.in)
                        ? "borderBottomMini"
                        : "borderBottomMiniConsole"
                    } w-[50%] font-bold text-xs left-[2px]`}
                  >
                    <Select
                      name="in"
                      className=""
                      options={railDimensions}
                      value={width.in}
                      handleSelect={(e) => handleRailHeightWidth(e, "width", 0)}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="my-4 border-t-2 border-slate-300 pt-4">
            <p className="font-semibold text-base txtBlue headingTxt">Rails</p>
            <div>
              {visibleRails.map(({ label, index }) => (
                <div
                  key={index}
                  className="flex items-center my-2 justify-between"
                >
                  <span className="txtBlue font-bold text-[13px] min-w-[50%]">
                    Rail <small className="text-xs font-normal">{label}</small>
                  </span>
                  <div className="mr-2">
                    {/* <div
                      className="rounded border border-slate-300 h-[32px] w-[32px] cursor-pointer"
                      style={{
                        backgroundColor: headwalls[index]?.color,
                        backgroundImage: `url(${
                          GRAINS[headwalls[index]?.background]
                        })`,
                      }}
                      onClick={() => {
                        if (headwalls[index]) {
                          setShowModal({ open: true, index });
                        }
                      }}
                    /> */}
                    {index > 0 && (
                      <Switch
                        name="rail"
                        value={!!headwalls[index]}
                        handleSwitch={(e) => handleInsightConsoleRails(e)}
                        isDisabled={index < 1 ? true : false}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="my-4 border-t-2 border-slate-300 pt-4">
            <div className="flex items-center my-2 justify-between">
              <p className="font-semibold text-base txtBlue headingTxt">
                Headwall Color
              </p>
              <div className="mr-2">
                <div
                  className="rounded border border-slate-300 h-[32px] w-[32px] cursor-pointer"
                  style={{
                    backgroundColor: headwalls[0]?.color,
                    backgroundImage: `url(${GRAINS[headwalls[0]?.background]})`,
                  }}
                  onClick={() => {
                    if (headwalls[0]) {
                      setShowModal({ open: true, index: 0 });
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="my-2">
          <p className="font-semibold text-base txtBlue headingTxt">
            Headwall Width (ft/inch)
          </p>
          <div className="items-center my-2">
            <div className="flex gap-3">
              <div className="selectwidth flex w-1/2 px-3 py-2 gap-4">
                <span className="borderBottomMini w-[50%] font-bold text-xs">
                  <Select
                    name="ft"
                    className=""
                    options={railDimensions}
                    value={width.ft}
                    handleSelect={(e) => handleRailHeightWidth(e, "width", 0)}
                  />
                </span>
                <span className="borderBottomMini w-[50%] font-bold text-xs">
                  <Select
                    name="in"
                    className=""
                    options={RAIL_INCHES}
                    value={width.in}
                    handleSelect={(e) => handleRailHeightWidth(e, "width", 0)}
                  />
                </span>
              </div>
              <div
                className="rounded border border-slate-300 h-[32px] w-[32px] cursor-pointer"
                style={{
                  backgroundColor: headwalls[0]?.color,
                  backgroundImage: `url(${GRAINS[headwalls[0]?.background]})`,
                }}
                onClick={() => {
                  setShowModal({ open: true, index: 0 });
                }}
              />
            </div>
            {width.ftError && (
              <div className=" flex items-center text-xs font-normal text-yellow-600 my-1">
                <img
                  src={AlertIcon}
                  alt="..img"
                  className="mx-2"
                  style={{ height: "20px" }}
                />
                {width.ftError}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const EloquenceDesignOptions = ({
  values,
  handleRailHeightWidth,
  setShowModal,
  railDimensions,
  handleEquolenceRails,
}) => {
  const { ceiling_height, headwalls, width, sub_model } = values;

  const rails = [
    { label: "1 (Default)", index: 0 },
    { label: "2 (Default)", index: 1 },
    { label: "3", index: 2 },
    { label: "4", index: 3 },
  ];
  // ✅ Show only 3 rails if sub_model === "rail"
  const visibleRails = sub_model === "rail" ? rails.slice(0, 3) : rails;

  return (
    <div className="my-4">
      <p className="font-semibold text-base txtBlue headingTxt">Rails</p>
      <div>
        {visibleRails.map(({ label, index }) => (
          <div key={index} className="flex items-center my-2">
            <span className="txtBlue font-bold text-[13px] min-w-[50%]">
              Rail <small className="text-xs font-normal">{label}</small>
            </span>
            <div className="grid items-center gap-5 grid-cols-2 ml-5">
              <div
                className="rounded border border-slate-300 h-[32px] w-[32px] cursor-pointer"
                style={{
                  backgroundColor: headwalls[index]?.color,
                  backgroundImage: `url(${
                    GRAINS[headwalls[index]?.background]
                  })`,
                }}
                onClick={() => {
                  if (headwalls[index]) {
                    setShowModal({ open: true, index });
                  }
                }}
              />
              {index > 1 && (
                <Switch
                  name="chased"
                  value={!!headwalls[index]}
                  handleSwitch={(e) => handleEquolenceRails(e, index)}
                  isDisabled={index < 2 ? true : false}
                />
              )}
            </div>
          </div>
        ))}
      </div>

      <HeadwallLength
        width={width}
        ceiling_height={ceiling_height}
        railDimensions={railDimensions}
        handleRailHeightWidth={handleRailHeightWidth}
      />
    </div>
  );
};

const HiddenHeadwallDesignOptions = ({
  values,
  handleRailHeightWidth,
  setShowModal,
  railDimensions,
  handleSlideDoor,
}) => {
  const { headwalls, width, add_rail, sub_model } = values;

  return (
    <>
      {sub_model === "single" && (
        <div className="my-4 border-b-2 border-slate-300 py-3">
          <p className="font-bold text-base txtBlue headingTxt">Panels</p>
          <div className="flex my-2 gap-5">
            <div className="w-[80px]">
              <Button
                className={`flex w-full h-12 flex-col border justify-center items-center py-2 px-4 rounded font-bold text-xs bg-white  right_panel_step_box_active cursor-pointer ${
                  add_rail === "right" ? "  opacity-100" : "opacity-50"
                }`}
                imgPath={SingleLeftIcon}
                handleClick={() => handleSlideDoor("right")}
                type={"button"}
                imgClass={"h-6 w-6"}
              />
              <div className="font-normal text-xs txtBlue flex justify-between mt-3 px-1">
                <p>Single Right</p>
              </div>
            </div>

            <div className="w-[80px]">
              <Button
                className={`flex w-full h-12 flex-col border justify-center items-center py-2 px-4 rounded font-bold text-xs  right_panel_step_box_active cursor-pointer  ${
                  add_rail === "left" ? "  opacity-100" : " opacity-50"
                }`}
                imgPath={SingleRightIcon}
                handleClick={() => handleSlideDoor("left")}
                type={"button"}
                imgClass={"h-6 w-6"}
              />
              <div className="font-normal text-xs txtBlue flex justify-between mt-3 px-1">
                <p>Single Left</p>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="my-4 ">
        <p className="font-semibold text-base txtBlue headingTxt">Sections</p>
        {headwalls.map((rail, index) => (
          <div>
            <div className="flex items-center justify-between  my-2">
              <span className="txtBlue font-normal text-base">
                Section
                <small className="text-sm font-normal"> {index + 1}</small>
              </span>

              <div>
                <div
                  className="rounded border border-slate-300 h-[36px] w-[36px] cursor-pointer"
                  style={{
                    backgroundColor: rail?.color,
                    backgroundImage: `url(${GRAINS[rail?.background]})`,
                  }}
                  onClick={() => setShowModal({ open: true, index: index })}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="border-t-2 border-slate-300 pt-5">
        <div className="flex items-center justify-between  my-2">
          <span className="txtBlue font-bold text-base">
            Rail
            <small className="text-sm font-normal"> Width (inch)</small>
          </span>

          <div
            className="grid items-center gap-2"
            style={{ gridTemplateColumns: "80px 22px" }}
          >
            <div className="selectwidth">
              <span className={`borderBottomMini font-bold text-xs`}>
                <Select
                  name="in"
                  className=""
                  options={railDimensions}
                  value={width.in}
                  handleSelect={(e) => handleRailHeightWidth(e, "width", 0)}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
